import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import isFunction from 'lodash/isFunction'

import Select from 'react-select'

import 'react-select/dist/react-select.css'

import FormControl from './FormControl'

export default class BirthdayInput extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    helpText: PropTypes.string,
    initialValue: PropTypes.any,
    disabled: PropTypes.bool,
    validationFuncs: PropTypes.array,
    loading: PropTypes.bool,
    searchable: PropTypes.bool,
    backspaceRemoves: PropTypes.bool,
    deleteRemoves: PropTypes.bool,
    extendedClass: PropTypes.string,
    onBlurExternal: PropTypes.func
  }

  static defaultProps = {
    disabled: false,
    validationFuncs: [],
    loading: false,
    initialValue: '2000-01-01',
    searchable: true,
    backspaceRemoves: true,
    deleteRemoves: true
  }

  getValue() {
    return this.state.value
  }

  handleBlur = () => {
    this.validate()

    if (isFunction(this.props.onBlurExternal)) {
      this.props.onBlurExternal()
    }
  }

  handleMonthChange = e => {
    const { value } = this.state

    const newValue = `${value.slice(0, 4)}-${e.value}-${value.slice(8, 10)}`

    this.handleChange(newValue)
    this.setState({
      value: newValue
    })
  }

  handleDayChange = e => {
    const { value } = this.state

    const newValue = `${value.slice(0, 7)}-${e.value}`

    this.handleChange(newValue)
    this.setState({
      value: newValue
    })
  }

  handleYearChange = e => {
    const { value } = this.state

    const newValue = `${e.value}-${value.slice(5, 10)}`

    this.handleChange(newValue)
    this.setState({
      value: newValue
    })
  }

  getDayOptions = () => {
    const days = []

    for (let i = 1; i < 32; i++) {
      const day = i < 10 ? `0${i}` : `${i}`

      days.push({
        label: day,
        value: day
      })
    }

    return days
  }

  getYearOptions = () => {
    const years = []

    for (let i = 1930; i < 2010; i++) {
      years.push({
        label: `${i}`,
        value: `${i}`
      })
    }
    return years
  }

  getMonthOptions = () => {
    return [
      {
        label: 'January',
        value: '01'
      },
      {
        label: 'February',
        value: '02'
      },
      {
        label: 'March',
        value: '03'
      },
      {
        label: 'April',
        value: '04'
      },
      {
        label: 'May',
        value: '05'
      },
      {
        label: 'June',
        value: '06'
      },
      {
        label: 'July',
        value: '07'
      },
      {
        label: 'August',
        value: '08'
      },
      {
        label: 'September',
        value: '09'
      },
      {
        label: 'October',
        value: '10'
      },
      {
        label: 'November',
        value: '11'
      },
      {
        label: 'December',
        value: '12'
      }
    ]
  }

  render() {
    const { id, label, labelClass, disabled, helpText, loading, searchable, extendedClass } = this.props

    const { value, errorMessage } = this.state

    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !this.state.isValid,
      [extendedClass]: !!extendedClass
    })

    const labelClassName = classNames({
      'margin-bottom-0-5': true,
      [labelClass]: !!labelClass
    })

    return (
      <fieldset className={groupClass} id={id}>
        {label && (
          <label htmlFor={id} className={labelClassName}>
            {label}
          </label>
        )}
        <div className="birthday-input-wrapper">
          <div className="birthday-input-day">
            <Select
              id={id}
              options={this.getDayOptions()}
              clearable={false}
              value={value.slice(8, 10)}
              onChange={this.handleDayChange}
              disabled={disabled}
              isLoading={loading}
              searchable={searchable}
            />
          </div>
          <div className="birthday-input-month">
            <Select
              clearable={false}
              options={this.getMonthOptions()}
              onChange={this.handleMonthChange}
              value={value.slice(5, 7)}
              disabled={disabled}
              isLoading={loading}
              searchable={searchable}
            />
          </div>
          <div className="birthday-input-year">
            <Select
              clearable={false}
              options={this.getYearOptions()}
              value={value.slice(0, 4)}
              onChange={this.handleYearChange}
              disabled={disabled}
              isLoading={loading}
              searchable={searchable}
            />
          </div>
        </div>
        {helpText && <small className="text-muted">{helpText}</small>}
        {errorMessage && <small className="text-danger">{errorMessage}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/BirthdayInput.jsx